import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { offerFilters } from '../offerFilterParams';

export const filterOptions = [
  { value: offerFilters.none, label: 'None' },
  { value: offerFilters.local, label: 'Local offer' },
  { value: offerFilters.nearMe, label: 'Near me' },
  { value: offerFilters.expireSoon, label: 'Expire soon' },
];

const FilterDropdown = ({ 
  anchorEl, 
  onClose, 
  selectedFilter = offerFilters.none,
  onFilterSelect 
}) => {
  const handleSelect = (filterValue) => {
    onFilterSelect(filterValue);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {filterOptions.map((option) => (
        <MenuItem
          key={option.value}
          selected={selectedFilter === option.value}
          onClick={() => handleSelect(option.value)}
          dense
        >
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default FilterDropdown;
